module.exports = __webpack_public_path__ + "img/GAME_TRAIN.3ff7e86c.png";